export default theme => ({
  root: {
    backgroundColor: theme.palette.common.customer,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    // paddingLeft: theme.spacing(1),
    // paddingRight: theme.spacing(1),
    direction: "rtl",
    right: 0
  },
  logoWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "63px",
    flexShrink: 0
  },
  logoLink: {
    fontSize: 0
  },
  logoImage: {
    cursor: "pointer",
    width: "150px"
  },
  logoDivider: {
    marginBottom: theme.spacing(2)
  },
  profile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "fit-content"
  },
  avatar: {
    width: "100px",
    height: "100px"
  },
  nameText: {
    marginTop: theme.spacing(2)
  },
  bioText: {},
  profileDivider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  listSubheader: {
    color: theme.palette.text.secondary
  },
  listItem: {
    cursor: "pointer",
    textAlign: "right",
    direction: "rtl",
    borderRadius: "20px",
    color: theme.palette.primary.customer,
    "&:hover": {
      backgroundColor: theme.palette.primary.customer,
      color: theme.palette.text.primary,
      // borderRadius: "20px",
      "& $listItemIcon": {
        color: theme.palette.primary.main
      }
    },
    "& + &": {
      marginTop: theme.spacing(1)
    }
  },
  listItemLtr: {
    cursor: "pointer",
    textAlign: "left",
    direction: "ltr",
    borderRadius: "20px",
    color: theme.palette.primary.customer,
    "&:hover": {
      backgroundColor: theme.palette.primary.customer,
      color: theme.palette.text.primary,
      // borderRadius: "20px",
      "& $listItemIcon": {
        color: theme.palette.primary.main
      }
    },
    "& + &": {
      marginTop: theme.spacing(1)
    }
  },
  activeListItem: {
    borderLeft: `5px solid ${theme.palette.primary.main}`,
    borderRadius: "20px",
    backgroundColor: theme.palette.primary.light,
    "& $listItemText": {
      color: theme.palette.text.primary
    },
    "& $listItemIcon": {
      color: theme.palette.primary.main,
      marginLeft: "-5px"
    }
  },
  listItemIcon: {
    marginRight: 0
  },
  listItemText: {
    fontWeight: 500,
    // color: theme.palette.text.light,
    // backgroundColor: theme.palette.text.primary,
    "&:hover": {
      // backgroundColor: theme.palette.primary.customer,
      color: "black",
      // borderRadius: "20px",
      "& $listItemIcon": {
        color: theme.palette.primary.main
      }
    }
  },
  listDivider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  itemtext: {
    color: "#f5f5f5",
    fontSize: "13px"
  },
  svgitem: {
    color: "#fdfdfd"
  },
  ltrSelectedItem: {
    cursor: "pointer",
    textAlign: "left",
    direction: "ltr",
    borderRadius: "20px",
    backgroundColor: theme.palette.primary.customer,
    color: theme.palette.text.primary
  },
  rtlSelectedItem: {
    cursor: "pointer",
    textAlign: "right",
    direction: "rtl",
    borderRadius: "20px",
    backgroundColor: theme.palette.primary.customer,
    color: theme.palette.text.primary
  }
});
